export default __webpack_public_path__ + "static/media/Opposites01_09.ec55545b.png";